export class PurchaseOrderImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchCode: number = 0;
    consecutive: number = 0;
    alterNumber: number = 0;
    purchaseOrderDate: Date = new Date();
    enterpriseCode: number = 0;
    providerDocument: string = "";
    address: string = "";
    wayToPayCode: number = 0;
    referenceDocument: string = "";
    purchaseOrderState: number = 0;
    observation: string | null = null;
    subtotalValue: number = 0;
    ivaValue: number = 0;
    articleCode: number = 0;
    quantity: number = 0;
    ajustedQuantity: number = 0;
    unitValue: number = 0;
    ajustedUnitValue: number = 0;
    discountRate: number = 0;
    ajustedDiscountRate: number = 0;
    ivaRate: number = 0;
    ajustedIvaRate: number = 0;
    internalOrderConsecutive: number | null = null;
    constructor(
        counter: number = 0,
        companyId: number = 0,
        branchCode: number = 0,
        consecutive: number = 0,
        alterNumber: number = 0,
        purchaseOrderDate: Date = new Date(),
        enterpriseCode: number = 0,
        providerDocument: string = "",
        address: string = "",
        wayToPayCode: number = 0,
        referenceDocument: string = "",
        purchaseOrderState: number = 0,
        observation: string | null = null,
        subtotalValue: number = 0,
        ivaValue: number = 0,
        articleCode: number = 0,
        quantity: number = 0,
        ajustedQuantity: number = 0,
        unitValue: number = 0,
        ajustedUnitValue: number = 0,
        discountRate: number = 0,
        ajustedDiscountRate: number = 0,
        ivaRate: number = 0,
        ajustedIvaRate: number = 0,
        internalOrderConsecutive: number | null = null
    ) {
        this.counter = counter;
        this.companyId = companyId;
        this.branchCode = branchCode;
        this.consecutive = consecutive;
        this.alterNumber = alterNumber;
        this.purchaseOrderDate = purchaseOrderDate;
        this.enterpriseCode = enterpriseCode;
        this.providerDocument = providerDocument;
        this.address = address;
        this.wayToPayCode = wayToPayCode;
        this.referenceDocument = referenceDocument;
        this.purchaseOrderState = purchaseOrderState;
        this.observation = observation;
        this.subtotalValue = subtotalValue;
        this.ivaValue = ivaValue;
        this.articleCode = articleCode;
        this.quantity = quantity;
        this.ajustedQuantity = ajustedQuantity;
        this.unitValue = unitValue;
        this.ajustedUnitValue = ajustedUnitValue;
        this.discountRate = discountRate;
        this.ajustedDiscountRate = ajustedDiscountRate;
        this.ivaRate = ivaRate;
        this.ajustedIvaRate = ajustedIvaRate;
        this.internalOrderConsecutive = internalOrderConsecutive;
    }
}